module.exports = __webpack_public_path__ + "static/media/vf_wknit_core.db63c7f8.svg";